import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import { ChargeDataSearchProvider } from 'presentation/store/ChargeDataEnquiry/ChargeDataSearchProvider';
import 'presentation/style/chargeDataEnquiry/chargeDataSearch.scss';
import 'presentation/style/index.scss';
import { ChargeDataEnquiryHeader } from 'presentation/view/container/ChargeDataEnquiry/ChargeDataEnquiryHeader';
import { ChargeDataEnquirySearch } from 'presentation/view/container/ChargeDataEnquiry/ChargeDataEnquirySearch';

CommonEntrypoint(<ChargeDataEnquirySearch />, <ChargeDataEnquiryHeader />, ChargeDataSearchProvider)